module.exports = __webpack_public_path__ + "static/media/map_img.df2b6ef8.png";